import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import i18n from "./plugins/i18n";
import vuetify from "./plugins/vuetify";
import VueApexCharts from "vue-apexcharts";
import { PermissionsPlugin } from "./shared/permissions";

Vue.config.productionTip = false;

Vue.use(VueApexCharts);
// this.$can("modulo.acao") / this.$isSuperAdmin() nas telas.
Vue.use(PermissionsPlugin, { store });
// eslint-disable-next-line vue/multi-word-component-names
Vue.component("apexchart", VueApexCharts);

import HeaderView from "@/components/content/HeaderView";
import FilterBar from "@/components/form/FilterBar.vue";
import CustomSearch from "@/components/form/CustomSearch.vue";
import CustomDialog from "@/components/form/CustomDialog.vue";
import CustomSelect from "@/components/form/CustomSelect.vue";
import CustomTable from "@/components/content/CustomTable.vue";
import CustomFileInput from "./components/form/CustomFileInput.vue";
import CustomMessageDialog from "./components/alerts/confirm-dialog.vue";
import CustomAutoComplete from "@/components/form/CustomTextField.vue";
import CustomMaskedField from "@/components/form/CustomMaskedField.vue";
import CustomFilePortrait from "./components/content/CustomFilePortrait.vue";
import CustomDebouncedTextField from "./components/form/CustomDebouncedTextField.vue";
import PageSkeleton from "./components/skeletons/PageSkeleton.vue";

Vue.component("filter-bar", FilterBar);
Vue.component("header-view", HeaderView);
Vue.component("custom-table", CustomTable);
Vue.component("custom-search", CustomSearch);
Vue.component("custom-dialog", CustomDialog);
Vue.component("custom-select", CustomSelect);
Vue.component("custom-alert", CustomMessageDialog);
Vue.component("custom-input", CustomAutoComplete);
Vue.component("custom-file-input", CustomFileInput);
Vue.component("custom-masked-input", CustomMaskedField);
Vue.component("custom-file-portait", CustomFilePortrait);
Vue.component("debounced-input", CustomDebouncedTextField);
// Carregamento das telas: esqueleto no formato da pagina, no lugar do spinner.
Vue.component("page-skeleton", PageSkeleton);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
